import React, { FC } from 'react'
import { AppBar, Box, IconButton, Toolbar, Typography } from '@mui/material'
import { Menu } from '@mui/icons-material'
import { getStandMeta } from '../sidebar/standMeta'
import { LogoHorizontalWhite } from '../icons'

interface MobileAppBarProps {
  onMenuClick: () => void
}

export const MobileAppBar: FC<MobileAppBarProps> = ({ onMenuClick }) => {
  const standMeta = getStandMeta()

  return (
    <AppBar position="sticky" elevation={0} sx={{ display: { xs: 'block', sm: 'none' }, bgcolor: standMeta.sidebarColor }}>
      <Toolbar variant="dense">
        <IconButton edge="start" color="inherit" onClick={onMenuClick} aria-label="open menu">
          <Menu />
        </IconButton>
        <Box display="flex" alignItems="center" ml={1} mr="auto">
          <LogoHorizontalWhite />
        </Box>
        <Typography variant="caption" color="white" textTransform="uppercase" sx={{ px: 1, borderRadius: 1, backgroundColor: standMeta.titleColor }}>
          {standMeta.name}
        </Typography>
      </Toolbar>
    </AppBar>
  )
}
